module.exports = __webpack_public_path__ + "static/media/library.910e96f4.png";